import React, { useEffect, useState } from "react";
import { Avatar, Button, Card, CardActions, CardMedia, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CardContent from "@mui/material/CardContent";
import { useDispatch, useSelector } from "react-redux";
import dummyRestro from "../../../images/CW/dummyRestro.png";
import { getDiff, ImgUrl } from "../../../constants/const";
import { useParams } from "react-router-dom";
import { getOtherUserDetail } from "../../../redux/action/recipe";
import { Modal } from "react-bootstrap";
import { Input, Spin } from "antd";
import DeleteIcon from "@mui/icons-material/Delete";
import SendIcon from "@mui/icons-material/Send";
import { addCommunityComments, getCommunityComments, getCommunityPost, likeCommunityPost, deleteCommunityComment, getCommunityPostLike, communityPostDetail } from "../../../redux/action/community";
import { FacebookShareButton } from "react-share";
import leafImg from "../../../images/CW/Icon awesome-leaf@2x.png";
import greenLeafImg from "../../../images/CW/Icon awesome-green-leaf@2x.png";
import commentImg from "../../../images/CW/Icon awesome-comment@2x.png";
import shareImg from "../../../images/CW/Icon ionic-ios-share-alt@2x.png";
import dummyProfile from "../../../images/CW/profile.jpeg";
import ReactHlsPlayer from "react-hls-player";

const { TextArea } = Input;

const OtherUserCommunity = () => {
  const dispatch = useDispatch();
  let { id } = useParams();
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [showRB, setShowRB] = useState(false);
  const [openCommentBox, setOpenCommentBox] = useState(false);
  const [message, setMessage] = useState("");
  const [commId, setCommId] = useState("");

  const [title, setTitle] = useState(null);
  const [description, setDesc] = useState(null);
  const [imageset, setImageset] = useState(null);
  const [type, setType] = useState("image");
  const [loading, setLoading] = useState(false);

  const community_data = useSelector((state) => state.recipe?.other_user_detail?.data?.community_data);
  const getCommunityPostLikesss = useSelector((state) => state?.community?.get_community_post_likes);
  const getCommunityPostComment = useSelector((state) => state?.community?.get_community_comment?.data);
  const getCommunityPostDetail = useSelector((state) => state?.community?.community_post_detail?.data);
  const userData = useSelector((state) => state.dashboard?.user_data);

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseDesc = () => {
    setShow(false);
    setType("image")
    setTitle(null)
    setDesc(null)
    setImageset(null)
  };
  const handleClickOpenDesc = (id) => {

    setTitle(null)
    setDesc(null)
    setImageset(null)
    const successCb = (res) => {
      setLoading(false)
      setTitle(res?.data?.title)
      setDesc(res?.data?.description)
      setImageset(res?.data?.media)
      setType(res?.data?.media_type)
      setShow(true)
    };
    let data = { community_post_id: id };
    dispatch(communityPostDetail(data, successCb));
  };

  const toggleImage = (dataId) => {
    const successCb = (resp) => {
      const successCb = () => { }
      let data = { community_post_id: dataId };
      dispatch(communityPostDetail(data, successCb));
    };
    let data = {
      community_post_id: dataId,
      page: 1,
    };
    dispatch(likeCommunityPost(data, successCb));
  };
  useEffect(() => {
    toggleImage()
  }, [userData])

  // Like Modal Start
  const handleShowLike = (id) => {
    setCommId(id);
    setShowRB(true);
    const successCb = (res) => {
    };
    let data = {
      community_post_id: id,
      comment: message,
      page: 1,
    };
    dispatch(getCommunityPostLike(data, successCb));
  };
  const handleCloseLike = () => setShowRB(false);
  // Like Modal End

  const handleOpenCommentBox = (id) => {
    setOpenCommentBox(true)
    setCommId(id);
    let data = {
      community_post_id: id,
      page: 1,
    };
    dispatch(getCommunityComments(data));
  }
  const handleCloseCommentBox = () => {
    setOpenCommentBox(false)
  }

  const addComment = () => {
    const successCb = (res) => {
      setTimeout(() => {
        let data = {
          community_post_id: commId,
          page: 1,
        };
        dispatch(getCommunityComments(data));
        let token = localStorage.getItem("token");
        dispatch(getCommunityPost(token, { page: '1' }));
        setMessage("");
      }, 500);
      return;
    };
    let data = {
      community_post_id: commId,
      comment: message,
      page: 1,
    };
    dispatch(addCommunityComments(data, successCb));
  };

  const deleteComment = (dataId) => {
    const successCb = (res) => {
      let data = {
        community_post_id: commId,
        page: 1,
      };
      dispatch(getCommunityComments(data));
      let token = localStorage.getItem("token");
      dispatch(getCommunityPost(token, { page: '1' }));
      return;
    };
    let data = {
      community_post_id: dataId?._id,
      comment_id: dataId?._id,
    };
    dispatch(deleteCommunityComment(data, successCb));
  };

  useEffect(() => {
    let token = localStorage.getItem("token");
    let data = { other_user_id: id }
    dispatch(getOtherUserDetail(data, token));
  }, []);

  return (
    <Box>
      <Box style={{ display: "flex", flexDirection: "row-reverse", color: "#000" }} >
        <Button className="see_more_card_btn" onClick={handleClickOpen}> See All </Button>
      </Box>
      <Grid container spacing={2}>
        {community_data?.length > 0 ? community_data?.map((data, id) => {
          return (
            <Grid item xs={12} sm={4} md={3} lg={2} key={id}>
              <Card onClick={() => handleClickOpenDesc(data?._id)} style={{ margin: "0", padding: "0", boxSizing: "border-box", position: "relative", boxShadow: "9px 9px 31px -10px rgba(0,0,0,0.75)", borderRadius: "10px", border: "2px solid orange", objectFit: "cover" }}>
                {data?.media_type === "image" ? (
                  <CardMedia component="img" image={data?.media !== "" ? `${ImgUrl}${data?.media}` : `${dummyRestro}`} alt="media" height="200px" />
                ) : (
                  data?.media?.includes('mp4') ?
                    <video width="100%" height="200" controls>
                      <source src={data?.media !== "" ? `${ImgUrl}${data?.media}` : ''} type="video/mp4" />
                    </video>
                    :
                    <ReactHlsPlayer
                      src={`${ImgUrl}${data?.media}`}
                      autoPlay={false}
                      width="100%"
                      height="200px"
                      style={{ objectFit: "cover" }}
                      controls
                    />
                )}
              </Card>
            </Grid>
          );
        }) : <p className="d-flex text-center mx-4" >No data added yet!</p>}
      </Grid>
      {/* To see All */}
      <Dialog open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title" style={{ width: "-webkit-fill-available" }}>
        <DialogContent>
          <Box style={{ display: "flex", alignItems: "center", }} > <KeyboardBackspaceIcon onClick={handleClose} fontSize="large" style={{ flex: "start", cursor: "pointer" }} /> </Box>
          <DialogContentText style={{ color: "#000", fontFamily: "Montserrat", fontWeight: "normal", display: "flex", textAlign: "center", }} >
            <Box style={{ margin: "0", padding: "0" }}>
              <CardContent>
                <Grid container spacing={2}>
                  {community_data?.length > 0 ? community_data?.map((data, id) => {
                    return (
                      <Grid item xs={12} sm={4} md={4} lg={4} key={id}>
                        {data?.media_type === "image" ? (
                          <CardMedia component="img" height="194" image={data?.media !== "" ? `${ImgUrl}${data?.media}` : `${dummyRestro}`} alt="dish_image" />
                        ) : (<video src={data?.media !== "" ? `${ImgUrl}${data?.media}` : ''} width="600" height="200" controls="controls" />)}
                      </Grid>
                    );
                  }) : <p className="d-flex text-center mx-4" >No data added yet!</p>}
                </Grid>
              </CardContent>
            </Box>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Show Details */}
      <Modal show={show} onHide={handleCloseDesc}>
        <Modal.Header closeButton ><Modal.Title>Community Post</Modal.Title></Modal.Header>
        <Modal.Body>
          <Spin spinning={loading}>
            <Box>
              <Box>
                <Box mt={2} textAlign="center">
                  {type == "image" ?
                    <CardMedia className="community_card" component='img' image={`${ImgUrl}${imageset}`} alt="img" />
                    :
                    imageset?.includes('mp4') ?
                      <video className="community_card" controls src={`${ImgUrl}${imageset}`} />
                      :
                      <ReactHlsPlayer
                        src={`${ImgUrl}${imageset}`}
                        className="community_card"
                        controls
                      />
                  }
                </Box>
              </Box>
              <Box>
                <p style={{ fontWeight: "bold", margin: "10px 10px 0" }}>{title}</p>
                <TextArea readOnly rows={2} value={description} style={{ margin: "10px 0", border: 0 }} />
              </Box>

              {/* Like, Share, Comment */}
              <CardActions className="d-flex justify-content-between">
                <Box style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", cursor: "pointer" }} >
                  <IconButton aria-label="add to favorites" onClick={() => toggleImage(getCommunityPostDetail?._id)} >
                    <img src={getCommunityPostDetail?.is_liked == 0 ? leafImg : greenLeafImg} alt="like_img" height={20} />&nbsp;
                    <Box onClick={() => handleShowLike(getCommunityPostDetail?._id)}>
                      <Typography className="small_font" style={{ color: `${getCommunityPostDetail?.is_liked == 0 ? "black" : "green"}`, }}>
                        {`${getCommunityPostDetail?.total_likes} ${getCommunityPostDetail?.total_likes > 1 ? "Likes" : "Like"}`}
                      </Typography>
                    </Box>
                  </IconButton>
                </Box>
                <Box style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", cursor: "pointer", }} onClick={() => handleOpenCommentBox(getCommunityPostDetail?._id)} >
                  <IconButton aria-label="comment">
                    <img src={commentImg} alt="like_img" height={20} className="me-1" />
                    <Typography className="text-dark small_font">{getCommunityPostDetail?.total_comments} Comment</Typography>
                  </IconButton>
                </Box>
                <FacebookShareButton url={`${ImgUrl}${getCommunityPostDetail?.media}`} quote={`"${getCommunityPostDetail?.title}"`} hashtag={`#${getCommunityPostDetail?.title}`} description={getCommunityPostDetail?.description} className="Demo__some-network__share-button" >
                  <Box style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", cursor: "pointer", }} >
                    <IconButton aria-label="share">
                      <img src={shareImg} alt="like_img" height={20} />&nbsp;
                      <Typography className="text-dark small_font">Share</Typography>
                    </IconButton>
                  </Box>
                </FacebookShareButton>
              </CardActions>
            </Box>
          </Spin>
        </Modal.Body>
      </Modal>

      {/* Like Box */}
      <Modal show={showRB} onHide={handleCloseLike} backdrop="static" keyboard={false} >
        <Modal.Header closeButton>
          <Modal.Title style={{ display: "flex", justifyContent: "center" }} > Likes </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {getCommunityPostLikesss?.data?.map((data, id) => (

            <Box className="liked_main_style" key={id}>
              <List sx={{ width: "100%", bgcolor: "background.paper", }} >
                <ListItem>
                  <ListItemAvatar>
                    <Avatar src={data?.user_id?.profile_pic != '' ? `${ImgUrl}${data?.user_id?.profile_pic}` : dummyProfile} />
                  </ListItemAvatar>
                  <ListItemText
                    style={{ color: "orange", fontWeight: "bolder" }}
                    primary={data?.user_id?.full_name}
                    secondary={getDiff(data?.updated_at)}
                  />
                </ListItem>
              </List>
            </Box>
          ))}
        </Modal.Body>
      </Modal>

      {/* Comment Box */}
      <Modal show={openCommentBox} onHide={() => handleCloseCommentBox()} backdrop="static" keyboard={false} >
        <Modal.Header closeButton >
          <Modal.Title style={{ fontWeight: "bold" }}>
            {/* <KeyboardBackspaceIcon onClick={() => handleCloseCommentBox()} fontSize="large" cursor="pointer" /> */}
            <span style={{ fontWeight: "bold", marginLeft: "30px" }}> Comments </span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Typography style={{ height: "30vh", padding: "10px 0", overflowY: "scroll", }} >
            {getCommunityPostComment?.length > 0 ? getCommunityPostComment?.map((data, id) => {
              return (
                <Box className="liked_main_style" key={id}>
                  <List sx={{ width: "100%", bgcolor: "background.paper", }} >
                    <ListItem secondaryAction={<IconButton edge="end" aria-label="delete" style={{ color: "orange" }} onClick={() => deleteComment(data)} > <DeleteIcon /> </IconButton>} >
                      <ListItemAvatar> <Avatar sx={{ width: 56, height: 56 }} style={{ marginRight: 10 }} src={data?.user_id?.profile_pic != '' ? `${ImgUrl}${data?.user_id?.profile_pic}` : dummyProfile} /> </ListItemAvatar>
                      <ListItemText style={{ wordBreak: 'break-all' }} primary={data?.user_id?.full_name} secondary={<>
                        <p style={{ padding: '0', margin: '0' }}> "{data?.comment}" </p>
                        <p style={{ padding: '0', margin: '0' }}>{getDiff(data?.created_at)}</p>
                      </>} />
                    </ListItem>
                  </List>
                </Box>
              );
            }) : <Box><p>No comments found!</p></Box>}
          </Typography>
          <Box style={{ display: "flex", border: "1px solid orange", margin: "5px 0 0 0", justifyContent: "space-between", padding: '5px 0' }} >
            <input autoFocus placeholder="Your Message..." size="large" value={message} onChange={(e) => { setMessage(e.target.value) }} style={{ outline: "none", border: "none", width: "100%", marginLeft: 10 }} />
            <Box onClick={() => addComment()} style={{ color: "orange", padding: '2px 5px', cursor: 'pointer' }} > <SendIcon /> </Box>
          </Box>
        </Modal.Body>
      </Modal>
    </Box>
  );
};
export default OtherUserCommunity;